import { Button, EmptyContent, ScrollArea } from '@/components/ui';
import { useSidebar } from '@/providers/SidebarContext';

import { IconFolder, IconX } from '@tabler/icons-react';

const Sidebar = () => {
  const { isOpen, closeSidebar } = useSidebar();

  // Don't render sidebar if it's not open
  if (!isOpen) {
    return null;
  }

  return (
    // <div className={`app-layout__sidebar ${isOpen ? 'sidebar--expanded' : 'sidebar--collapsed'}`}>
    <div className="app-layout__sidebar sidebar--expanded">
      <ScrollArea className="sidebar-scroll-area">
        <div className="sidebar-header">
          <Button isIconOnly onClick={closeSidebar} className="close-button">
            <IconX />
          </Button>

          <EmptyContent
            disableAnimation
            icon={<IconFolder />}
            title={'Sidebar'}
            description={'Add your sidebar menu items here'}
            size="small"
          />
        </div>
      </ScrollArea>
    </div>
  );
};

export default Sidebar;
